<template>
    <v-card
        @click="$emit('clear-model')"
        :to="{
            name: 'CommunityList',
            params: { category: category.id, id: item.id },
        }"
        :width="$vuetify.breakpoint.xl ? '86%' : '100%'"
        color="transparent"
        class="mt-3"
    >
        <v-card-text class="pb-0">
            <p class="text-caption mb-2">
                {{ itemDate
                }}<span v-if="countryNames">, {{ countryNames }}</span>
            </p>
        </v-card-text>
        <v-card-title class="py-0 primary--text">{{
            item.heading
        }}</v-card-title>
        <p
            v-if="item.category === 'template' && item.nameOfAuthority"
            class="text-caption px-3 ma-0 py-2"
        >
            {{ $t('community.authority') }} {{ item.nameOfAuthority }}
        </p>
        <v-card-text>
            <div v-if="item.category !== 'lea_news'" class="text-caption">{{ $htmlSnippet(textContent, 220) }}</div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateTypes, parseISO, formatDate } from '@/utils/dateFns';

export default {
    props: {
        category: Object,
        item: Object,
    },
    i18n: {
        messages: {
            en: require('@/locales/Community/en.json'),
            de: require('@/locales/Community/de.json'),
        },
    },
    computed: {
        ...mapGetters({
            findCountryByCode: 'countries/findByCountryCode',
        }),
        itemDate() {
            if (this.item.date.substring(0, 4) === '1920') {
                return this.$i18n.t('community.groups.date.unknownDate');
            }
            return formatDate(parseISO(this.item.date), dateTypes.fullDateTime);
        },
        textContent() {
            if (this.item.summary && this.item.summary.length > 8) {
                return this.item.summary;
            }
            return this.item.content;
        },
        countryNames() {
            let strCountries = '';
            this.item.countries.forEach((x, i) => {
                const country = this.findCountryByCode(x);
                strCountries += country
                    ? i > 1
                        ? ', ' + country.countryName
                        : country.countryName
                    : null;
            });
            return strCountries;
        },
    },
};
</script>
